(function (Drupal) {
  Drupal.behaviors.researchAndEducation = {
    attach: function (context, settings) {
      if (document.body.classList.contains('page-view-investigation-education')) {
        const titlePage = document.querySelector('.view-investigation-education .view-header', context);
        const containerBack = document.querySelector('#block-subtheme-keralty-back-2', context);
   
        if (titlePage && containerBack && !containerBack.classList.contains("header-inserted")) {
          containerBack.classList.add("research-and-education-header", "header-inserted");
          containerBack.insertBefore(titlePage, containerBack.firstChild);
          titlePage.classList.remove("d-none");
        }
      }
    }
  };
})(Drupal);
